let customNavigationTranslator;

export function defineCustomNavigationTranslator() {
  const _org_defineProperty = Object.defineProperty;

  let block = 1;

  Object.defineProperty = function (obj, prop, descriptor) {
    if (prop == 'navigationTranslator' && block) {
      customNavigationTranslator = new Ef(null, []);
      descriptor = {
        ...descriptor,
        get: function () {
          return customNavigationTranslator.publicNavigationTranslator;
        }
      };
      Object.defineProperty = _org_defineProperty;
    }
    return _org_defineProperty(obj, prop, descriptor);
  };
}

export function initCustomNavigationTranslator(essential, lang) {
  const { resources } = essential._mapviewer.getExtraData();
  const { localized } = resources[lang] || resources['default'];
  const { venueLayout } = localized.locale[lang];

  // Add short floor names into places
  const vg_places = Object.entries(venueLayout).reduce(
    (acc, [id, floor]) => ((acc[id] = { name: floor.shortName }), acc),
    { ...essential.content.places }
  );

  customNavigationTranslator.mapviewer = essential._mapviewer;
  customNavigationTranslator.vgPlaces = vg_places;
}

function Pd() {}
Pd.create = function (t, e, i, n, r) {
  (t = t || {}),
    (i = i || []),
    (n = n || []),
    (r = r || []),
    Object.keys(i).forEach(function (t) {
      var n = i[t];
      void 0 !== e[n] &&
        Object.defineProperty(this, n, {
          get: function () {
            return e[n];
          },
          set: function (t) {
            e[n] = t;
          }
        });
    }, t),
    Object.keys(n).forEach(function (t) {
      var i = n[t];
      void 0 !== e[i] &&
        Object.defineProperty(this, i, {
          get: function () {
            return e[i];
          }
        });
    }, t),
    Object.keys(r).forEach(function (t) {
      var i = r[t];
      void 0 !== e[i] &&
        (this[i] = function () {
          return e[i].apply(e, arguments);
        });
    }, t),
    (t.destroyPublicInterface = function () {
      Object.keys(r).forEach(function (e) {
        var i = r[e];
        t[i] = null;
      }),
        (e = null);
    });
};

var _f = [],
  Mf = [],
  Sf = [
    'addOrUpdateLanguage',
    'getLanguage',
    'getLanguageCodes',
    'translateInstructions',
    'updateManeuverForLanguage',
    'updateNextManeuverForLanguage',
    'updateKeywordForLanguage',
    'updateDurationForLanguage'
  ];

function Tf(t) {
  Pd.create(this, t, _f, Mf, Sf);
}

function Ef(t, e) {
  (this.mapviewer = t),
  (this.destinations = !1),
  (this.vgPlaces = e),
  (this.cLanguageMap = {
      en: {
        maneuvers: {
          unknown: '<unknown>',
          goStraight: 'Go straight',
          turnGentleRight: 'Turn gentle right',
          turnGentleLeft: 'Turn gentle left',
          turnRight: 'Turn right',
          turnLeft: 'Turn left',
          turnSharpRight: 'Turn sharp right',
          turnSharpLeft: 'Turn sharp left',
          UTurnRight: 'Make right U-turn',
          UTurnLeft: 'Make left U-turn',
          start: 'Start',
          end: 'You have arrived',
          goUp: 'Go up to floor %L',
          goDown: 'Go down to floor %L',
          changeModality: 'Use transportation mode: %M',
          changeLayer: 'Change building',
          waypoint: 'Stop'
        },
        nextManeuvers: {
          unknown: '<unknown>',
          goStraight: 'go straight',
          turnGentleRight: 'turn gentle right',
          turnGentleLeft: 'turn gentle left',
          turnRight: 'turn right',
          turnLeft: 'turn left',
          turnSharpRight: 'turn sharp right',
          turnSharpLeft: 'turn sharp left',
          UTurnRight: 'make right U-turn',
          UTurnLeft: 'make left U-turn',
          start: 'start',
          end: 'you have arrived',
          goUp: 'go up',
          goDown: 'go down',
          changeModality: 'change transportation mode: %M',
          changeLayer: 'change building',
          waypoint: 'stop'
        },
        keywords: {
          for: ' for ',
          then: ' then ',
          and: ' and ',
          near: ' near ',
          using: ' using ',
          stairway: 'the stairway',
          escalator: 'the escalator',
          lift: 'the lift'
        },
        durations: {
          seconds: 'a few seconds',
          oneMinute: 'about a minute',
          minutes: 'about %d minutes'
        }
      },
      fr: {
        maneuvers: {
          unknown: '<inconnu>',
          goStraight: 'Continuez tout droit',
          turnGentleRight: 'Tournez légèrement à droite',
          turnGentleLeft: 'Tournez légèrement à gauche',
          turnRight: 'Tournez à droite',
          turnLeft: 'Tournez à gauche',
          turnSharpRight: 'Tournez fortement à droite',
          turnSharpLeft: 'Tournez fortement à gauche',
          UTurnRight: 'Effectuez un demi-tour à droite',
          UTurnLeft: 'Effectuez un demi-tour à gauche',
          start: 'Départ',
          end: 'Arrivée',
          goUp: "Montez à l'étage %L",
          goDown: "Descendez à l'étage %L",
          changeModality: 'Changez de moyen de transport: %M',
          changeLayer: 'Changez de bâtiment',
          waypoint: 'Arrêtez vous'
        },
        nextManeuvers: {
          unknown: '<inconnu>',
          goStraight: 'continuez tout droit',
          turnGentleRight: 'tournez légèrement à droite',
          turnGentleLeft: 'tournez légèrement à gauche',
          turnRight: 'tournez à droite',
          turnLeft: 'tournez à gauche',
          turnSharpRight: 'tournez fortement à droite',
          turnSharpLeft: 'tournez fortement à gauche',
          UTurnRight: 'effectuez un demi-tour à droite',
          UTurnLeft: 'effectuez un demi-tour à gauche',
          start: 'départ',
          end: 'vous serez arrivés',
          goUp: 'montez',
          goDown: 'descendez',
          changeModality: 'changez de moyen de transport: %M',
          changeLayer: 'changez de bâtiment',
          waypoint: 'arrêt'
        },
        keywords: {
          for: ' pendant ',
          then: ' puis ',
          and: ' et ',
          near: ' à proximité de ',
          using: ' en empruntant ',
          stairway: 'les escaliers',
          escalator: "l'escalator",
          lift: "l'ascenseur"
        },
        durations: {
          seconds: 'quelques secondes',
          oneMinute: 'environ une minute',
          minutes: 'environ %d minutes'
        }
      }
    }),
    (this.publicNavigationTranslator = new Tf(this));
}

Ef.prototype.getIDFromDestinationIndex = function (t) {
  if ('string' == typeof this.destinations) return this.destinations;
  if (
    !1 === this.destinations ||
    !Array.isArray(this.destinations) ||
    t < 0 ||
    t >= this.destinations.length
  )
    return !1;
  var e = this.destinations[t];
  return 'string' == typeof e ? e : 'string' == typeof e.id && e.id;
};

Ef.prototype.getPlaceNameFromDestinationIndex = function (t) {
  var e = this.getIDFromDestinationIndex(t);
  return !1 !== e && this.getPlaceNameFromID(e);
};

Ef.prototype.getPlaceNameFromID = function (t) {
  var e = this.mapviewer.getPlaceName(t);
  if (Array.isArray(e) && e.length > 1) return e[0];
  if (!e) {
    var i = this.vgPlaces;
    void 0 !== i && void 0 !== i[t] && (e = i[t].name);
  }
  return e;
};

Ef.prototype.cManeuverIndex = {
  eVgManeuverTypeUnknown: 0,
  eVgManeuverTypeGoStraight: 1,
  eVgManeuverTypeTurnGentleRight: 2,
  eVgManeuverTypeTurnGentleLeft: 3,
  eVgManeuverTypeTurnRight: 4,
  eVgManeuverTypeTurnLeft: 5,
  eVgManeuverTypeTurnSharpRight: 6,
  eVgManeuverTypeTurnSharpLeft: 7,
  eVgManeuverTypeUTurnRight: 8,
  eVgManeuverTypeUTurnLeft: 9,
  eVgManeuverTypeStart: 10,
  eVgManeuverTypeEnd: 11,
  eVgManeuverTypeGoUp: 12,
  eVgManeuverTypeGoDown: 13,
  eVgManeuverTypeChangeModality: 14,
  eVgManeuverTypeChangeLayer: 15,
  eVgManeuverTypeWaypoint: 16
};

Ef.prototype.cManeuverTypes = [
  'unknown',
  'goStraight',
  'turnGentleRight',
  'turnGentleLeft',
  'turnRight',
  'turnLeft',
  'turnSharpRight',
  'turnSharpLeft',
  'UTurnRight',
  'UTurnLeft',
  'start',
  'end',
  'goUp',
  'goDown',
  'changeModality',
  'changeLayer',
  'waypoint'
];
Ef.prototype.cDurations = ['seconds', 'oneMinute', 'minutes'];
Ef.prototype.cKeywords = ['for', 'then', 'and', 'near', 'using', 'stairway', 'escalator', 'lift'];

Ef.prototype.translateInstructions = function (t, e) {
  var i = void 0 !== e && 'default' !== e && void 0 !== this.cLanguageMap[e] ? e : 'en';
  (this.destinations = !1),
    t.route && t.route.request && t.route.request.dst && (this.destinations = t.route.request.dst);
  for (var n = 0, r = t.instructions.length; n < r; n++)
    this.translateInstruction(t.instructions, n, i, t.parameters.mergeFloorChangeInstructions);
};

/**
 * @param {object[]} instructions
 * @param {number} index
 * @param {string} lang
 * @param {boolean?} mergeFloorChangeInstructions
 */
Ef.prototype.translateInstruction = function (
  instructions,
  index,
  lang,
  mergeFloorChangeInstructions
) {
  var r = lang || 0;
  mergeFloorChangeInstructions = mergeFloorChangeInstructions || !1;
  var a = !1,
    count = instructions.length,
    curr = instructions[index],
    next = instructions[index + 1],
    h = this.cManeuverTypes[this.cManeuverIndex[curr.maneuverType]],
    brief = '',
    duration_str = '',
    detail = '',
    d = '',
    m = '';
  switch (curr.maneuverType) {
    case 'eVgManeuverTypeEnd':
      (brief = this.cLanguageMap[r].maneuvers[h]),
        (g = this.getPlaceNameFromDestinationIndex(curr.destinationIndex)) &&
          ((brief += ': ' + g), (a = !0));
      break;
    case 'eVgManeuverTypeChangeModality':
    case 'eVgManeuverTypeChangeLayer':
    case 'eVgManeuverTypeGoDown':
    case 'eVgManeuverTypeGoUp':
    case 'eVgManeuverTypeStart':
      brief = this.cLanguageMap[r].maneuvers[h];
      break;
    case 'eVgManeuverTypeWaypoint':
      if (void 0 !== curr.destinationIndex)
        (brief = this.cLanguageMap[r].maneuvers.waypoint),
          (v = this.getPlaceNameFromDestinationIndex(curr.destinationIndex)) &&
            ((brief += ': ' + v), (a = !0));
      break;
    case 'eVgManeuverTypeGoStraight':
      brief = this.cLanguageMap[r].maneuvers.goStraight;
      duration_str = this.cLanguageMap[r].keywords.for + this.timeToText(curr.duration / 60, r);
      if (mergeFloorChangeInstructions) {
        if (!next) {
          (detail = this.cLanguageMap[r].keywords.then + this.cLanguageMap[r].nextManeuvers.end),
            (g = this.getPlaceNameFromDestinationIndex(curr.destinationIndex)) &&
              ((detail += ': ' + g), (a = !0));
          break;
        }
        if (
          (curr.dataset != (next && next.dataset)
            ? ((detail =
                next.height > curr.height
                  ? this.cLanguageMap[r].keywords.then + this.cLanguageMap[r].nextManeuvers.goUp
                  : next.height < curr.height
                  ? this.cLanguageMap[r].keywords.then + this.cLanguageMap[r].nextManeuvers.goDown
                  : this.cLanguageMap[r].keywords.then +
                    this.cLanguageMap[r].nextManeuvers.changeLayer),
              next.modality != curr.modality &&
                (detail +=
                  this.cLanguageMap[r].keywords.and +
                  this.cLanguageMap[r].nextManeuvers.changeModality))
            : next.modality != curr.modality &&
              (detail +=
                this.cLanguageMap[r].keywords.then +
                this.cLanguageMap[r].nextManeuvers.changeModality),
          next && next.destinationIndex !== curr.destinationIndex)
        )
          (detail +=
            this.cLanguageMap[r].keywords.then + this.cLanguageMap[r].nextManeuvers.waypoint),
            (v = this.getPlaceNameFromDestinationIndex(curr.destinationIndex)) &&
              ((detail += ': ' + v), (a = !0));
      } else if (index < count - 1) {
        var f = this.cManeuverTypes[this.cManeuverIndex[next.maneuverType]];
        switch (next.maneuverType) {
          case 'eVgManeuverTypeChangeLayer':
          case 'eVgManeuverTypeEnd':
            var g;
            (detail = this.cLanguageMap[r].keywords.then + this.cLanguageMap[r].nextManeuvers[f]),
              (g = this.getPlaceNameFromDestinationIndex(next.destinationIndex)) &&
                ((detail += ': ' + g), (a = !0));
            break;
          case 'eVgManeuverTypeGoDown':
          case 'eVgManeuverTypeGoUp':
            detail = this.cLanguageMap[r].keywords.then + this.cLanguageMap[r].nextManeuvers[f];
            break;
          case 'eVgManeuverTypeWaypoint':
            var v;
            (detail = this.cLanguageMap[r].keywords.then + this.cLanguageMap[r].nextManeuvers[f]),
              (v = this.getPlaceNameFromDestinationIndex(next.destinationIndex)) &&
                ((detail += ': ' + v), (a = !0));
        }
      }
      break;
    default:
      (brief = this.cLanguageMap[r].maneuvers.goStraight),
        (duration_str = this.cLanguageMap[r].keywords.for + this.timeToText(curr.duration / 60, r)),
        (detail = this.cLanguageMap[r].keywords.then + this.cLanguageMap[r].nextManeuvers[h]);
  }
  var y = curr.nearPlaces;
  if (
    (((mergeFloorChangeInstructions && index >= count - 1) ||
      (!mergeFloorChangeInstructions && index >= count - 2)) &&
      (a = !0),
    'eVgManeuverTypeGoUp' == curr.maneuverType ||
      'eVgManeuverTypeGoDown' == curr.maneuverType ||
      (!mergeFloorChangeInstructions &&
        index < count - 2 &&
        ('eVgManeuverTypeGoUp' == instructions[index + 1].maneuverType ||
          'eVgManeuverTypeGoDown' == instructions[index + 1].maneuverType)) ||
      (mergeFloorChangeInstructions &&
        index < count - 1 &&
        curr.height != instructions[index + 1].height))
  )
    for (var x = !1, b = 0, w = curr.attributes.length; b < w; b++) {
      switch (curr.attributes[b]) {
        case 'stairway':
          (m = this.cLanguageMap[r].keywords.using + this.cLanguageMap[r].keywords.stairway),
            (x = !0);
          break;
        case 'escalator':
          (m = this.cLanguageMap[r].keywords.using + this.cLanguageMap[r].keywords.escalator),
            (x = !0);
          break;
        case 'lift':
          (m = this.cLanguageMap[r].keywords.using + this.cLanguageMap[r].keywords.lift), (x = !0);
      }
      if (x) break;
    }
  if (!a && y && y.length > 0) {
    var _ = y[0].id,
      M = this.getPlaceNameFromID(_);
    !1 !== M &&
      'eVgManeuverTypeChangeModality' != curr.maneuverType &&
      'eVgManeuverTypeChangeLayer' != curr.maneuverType &&
      'eVgManeuverTypeEnd' != curr.maneuverType &&
      (d = this.cLanguageMap[r].keywords.near + M);
  }
  (curr.detail = brief + detail), //brief + duration_str + detail, // REMOVE duration detail
    ((detail && '' != detail) ||
      'eVgManeuverTypeGoUp' == curr.maneuverType ||
      'eVgManeuverTypeGoDown' == curr.maneuverType) &&
      (curr.detail += m + d),
    (curr.brief = brief),
    (curr.durationString = duration_str),
    (curr.detail = this.replaceTokens(curr.detail, curr, next)),
    (curr.brief = this.replaceTokens(curr.brief, curr, next)),
    (curr.durationString = this.replaceTokens(curr.durationString, curr, next));
};

Ef.prototype.replaceTokens = function (t, e, i) {
  if (void 0 !== e) {
    var n = Math.floor(e.duration / 60);
    t = (t = (t = t.replace('%d', n)).replace('%m', e.modality)).replace(
      '%l',
      this.getPlaceNameFromID(e.dataset) || e.dataset
    );
  }
  return (
    void 0 !== i &&
      (t = (t = t.replace('%M', i.modality)).replace(
        '%L',
        this.getPlaceNameFromID(i.dataset) || i.dataset
      )),
    t
  );
};

Ef.prototype.timeToText = function (t, e) {
  return t < 1
    ? this.cLanguageMap[e].durations.seconds
    : t < 2
    ? this.cLanguageMap[e].durations.oneMinute
    : this.cLanguageMap[e].durations.minutes;
};

Ef.prototype.addOrUpdateLanguage = function (t, e) {
  if (void 0 === t) return console.log('Invalid language code.'), !1;
  var i = 'default' === t ? 'en' : t,
    n = JSON.parse(e);
  if (void 0 === n.maneuvers)
    return (
      console.log("Could not add or update language '" + i + "': missing maneuvers."),
      console.log(
        'Expected format: ',
        JSON.parse('{"maneuvers": {},"nextManeuvers":{},"keywords":{},"durations":{}}')
      ),
      console.log("Try getLanguage('default') for more info."),
      !1
    );
  if (void 0 === n.nextManeuvers)
    return (
      console.log("Could not add or update language '" + i + "': missing nextManeuvers."),
      console.log(
        'Expected format: ',
        JSON.parse('{"maneuvers": {},"nextManeuvers":{},"keywords":{},"durations":{}}')
      ),
      console.log("Try getLanguage('default') for more info."),
      !1
    );
  if (void 0 === n.keywords)
    return (
      console.log("Could not add or update language '" + i + "': missing keywords."),
      console.log(
        'Expected format: ',
        JSON.parse('{"maneuvers": {},"nextManeuvers":{},"keywords":{},"durations":{}}')
      ),
      console.log("Try getLanguage('default') for more info."),
      !1
    );
  if (void 0 === n.durations)
    return (
      console.log("Could not add or update language '" + i + "': missing durations."),
      console.log(
        'Expected format: ',
        JSON.parse('{"maneuvers": {},"nextManeuvers":{},"keywords":{},"durations":{}}')
      ),
      console.log("Try getLanguage('default') for more info."),
      !1
    );
  Object.entries(n.maneuvers).forEach((k, v) => this.checkTokens(v, k)),
    Object.entries(n.nextManeuvers).forEach(([k, v]) => {
      return this.checkTokens(v, k, !0);
    }),
    Object.entries(n.keywords).forEach((k, v) => this.checkTokens(v, k)),
    Object.entries(n.durations).forEach((k, v) => this.checkTokens(v, k));
  var r = this.cManeuverTypes.filter(function (t) {
      return 'string' != typeof n.maneuvers[t];
    }),
    a = this.cManeuverTypes.filter(function (t) {
      return 'string' != typeof n.nextManeuvers[t];
    }),
    s = this.cKeywords.filter(function (t) {
      return 'string' != typeof n.keywords[t];
    }),
    o = this.cDurations.filter(function (t) {
      return 'string' != typeof n.durations[t];
    });
  return r.length > 0
    ? (console.log('Could not add or update language, missing maneuvers:'),
      console.log.apply(null, r),
      console.log("Try getLanguage('default') for more info."),
      !1)
    : a.length > 0
    ? (console.log('Could not add or update language, missing next maneuvers:'),
      console.log.apply(null, a),
      console.log("Try getLanguage('default') for more info."),
      !1)
    : s.length > 0
    ? (console.log('Could not add or update language, missing keywords:'),
      console.log.apply(null, s),
      console.log("Try getLanguage('default') for more info."),
      !1)
    : o.length > 0
    ? (console.log('Could not add or update language, missing durations:'),
      console.log.apply(null, o),
      console.log("Try getLanguage('default') for more info."),
      !1)
    : ((this.cLanguageMap[i] = n), !0);
};

Ef.prototype.getLanguageCodes = function () {
  return Object.keys(this.cLanguageMap);
};

Ef.prototype.getLanguage = function (t) {
  var e = 'default' === t ? 'en' : t;
  return void 0 !== this.cLanguageMap[e] && JSON.stringify(this.cLanguageMap[e]);
};

Ef.prototype.updateManeuverForLanguage = function (t, e, i) {
  var n = 'default' === e ? 'en' : e;
  return void 0 !== this.cLanguageMap[n]
    ? -1 !== this.cManeuverTypes.indexOf(t)
      ? (this.checkTokens(i, t), (this.cLanguageMap[n].maneuvers[t] = i), !0)
      : (console.log('Invalid maneuver type.'), !1)
    : (console.log('Invalid language code.'), !1);
};

Ef.prototype.updateNextManeuverForLanguage = function (t, e, i) {
  var n = 'default' === e ? 'en' : e;
  return void 0 !== this.cLanguageMap[n]
    ? -1 !== this.cManeuverTypes.indexOf(t)
      ? (this.checkTokens(i, t, !0), (this.cLanguageMap[n].nextManeuvers[t] = i), !0)
      : (console.log('Invalid maneuver type.'), !1)
    : (console.log('Invalid language code.'), !1);
};

Ef.prototype.updateKeywordForLanguage = function (t, e, i) {
  var n = 'default' === e ? 'en' : e;
  return void 0 !== this.cLanguageMap[n]
    ? -1 !== this.cKeywords.indexOf(t)
      ? (this.checkTokens(i, t), (this.cLanguageMap[n].keywords[t] = i), !0)
      : (console.log('Invalid keyword type.'), !1)
    : (console.log('Invalid language code.'), !1);
};

Ef.prototype.updateDurationForLanguage = function (t, e, i) {
  var n = 'default' === e ? 'en' : e;
  return void 0 !== this.cLanguageMap[n]
    ? -1 !== this.cDurations.indexOf(t)
      ? (this.checkTokens(i, t), (this.cLanguageMap[n].durations[t] = i), !0)
      : (console.log('Invalid duration type.'), !1)
    : (console.log('Invalid language code.'), !1);
};

Ef.prototype.checkTokens = function (value, key, i) {
  switch (key) {
    case 'goUp':
      -1 !== value.indexOf('%L') ||
        i ||
        console.log("Warning: missing %L token in 'goUp' maneuver.");
      break;
    case 'goDown':
      -1 !== value.indexOf('%L') ||
        i ||
        console.log("Warning: missing %L token in 'goDown' maneuver.");
      break;
    case 'changeModality':
      -1 === value.indexOf('%M') &&
        console.log("Warning: missing %M token in 'changeModality' maneuver or next maneuver.");
      break;
    case 'minutes':
      -1 === value.indexOf('%d') && console.log("Warning: missing %d token in 'minutes' duration.");
  }
};
